import type { RubyPublicContext } from '@/hooks/useRubyPublicChat';

/**
 * Maps the current URL to the same `pageInfo` strings used for public Ruby context (formerly per-page `RubyPublicFAB`).
 * Used by `Navbar` so public Ruby chat stays context-aware without a fixed FAB.
 */
export function pathnameToRubyLandingContext(pathname: string): RubyPublicContext {
  const path = pathname.split('?')[0].replace(/\/$/, '') || '/';

  if (path === '/') {
    return { type: 'landing', pageInfo: 'home' };
  }
  if (path === '/how-it-works') {
    return { type: 'landing', pageInfo: 'how-it-works' };
  }
  if (path === '/protect') {
    return { type: 'landing', pageInfo: 'protect' };
  }
  if (path === '/b2b') {
    return { type: 'landing', pageInfo: 'b2b' };
  }
  if (path === '/investors') {
    return { type: 'landing', pageInfo: 'investors' };
  }
  if (path.startsWith('/investors/press/')) {
    return { type: 'landing', pageInfo: 'investors' };
  }
  if (path === '/webinars') {
    return { type: 'landing', pageInfo: 'webinars' };
  }
  const webinarMatch = path.match(/^\/webinars\/([^/]+)$/);
  if (webinarMatch) {
    return { type: 'landing', pageInfo: `webinar-${webinarMatch[1]}` };
  }
  if (path === '/partners') {
    return { type: 'landing', pageInfo: 'partners' };
  }
  if (path === '/contact-us') {
    return { type: 'landing', pageInfo: 'contact-us' };
  }
  if (path === '/contact-sales') {
    return { type: 'landing', pageInfo: 'contact-sales' };
  }
  if (path === '/careers') {
    return { type: 'landing', pageInfo: 'careers' };
  }
  if (path === '/learn') {
    return { type: 'landing', pageInfo: 'blog' };
  }
  if (/^\/learn\/[^/]+$/.test(path)) {
    return { type: 'landing', pageInfo: 'blog-article' };
  }
  if (path === '/partner-blog') {
    return { type: 'landing', pageInfo: 'partner-blog' };
  }
  if (/^\/partner-blog\/[^/]+$/.test(path)) {
    return { type: 'landing', pageInfo: 'partner-blog-article' };
  }
  if (path === '/predictions') {
    return { type: 'landing', pageInfo: 'predictions' };
  }
  if (path === '/breaches') {
    return { type: 'landing', pageInfo: 'breaches' };
  }
  if (/^\/breaches\/[^/]+$/.test(path)) {
    return { type: 'landing', pageInfo: 'breach-article' };
  }
  if (path === '/help') {
    return { type: 'landing', pageInfo: 'help' };
  }
  if (path.startsWith('/join/')) {
    return { type: 'landing', pageInfo: 'campaign' };
  }
  if (path === '/reklaim-invest') {
    return { type: 'landing', pageInfo: 'Reklaim Invest / S4R page' };
  }
  if (path === '/download-app') {
    return { type: 'landing', pageInfo: 'download-app' };
  }
  if (path === '/optout') {
    return { type: 'landing', pageInfo: 'optout' };
  }
  if (path === '/hnwi') {
    return { type: 'landing', pageInfo: 'protect' };
  }
  if (path === '/signals') {
    return { type: 'landing', pageInfo: 'signals' };
  }

  const slug = path.replace(/^\//, '') || 'home';
  return { type: 'landing', pageInfo: slug };
}
